module.exports = __webpack_public_path__ + "static/media/feed_inspector_intro.287adbc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Twitch/Preview/img/feed_inspector_intro.png
// module id = 233
// module chunks = 0